// extracted by mini-css-extract-plugin
export default {"bg":"aLyQce","ant":"bLyQce","redTheme":"cLyQce","greenTheme":"dLyQce"};